<template>
  <div>
    <QS-h4-title title="相关应收信息" />
    <el-form label-width="140px">
      <column-box
        :source="source"
        :list="list"
        :column="3"
        :label-width="130"
      >
      </column-box>
    </el-form>
  </div>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'
import { mapState } from 'vuex'

export default {
  props: {
    source: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    source: {
      handler(val) {
        this.source.receivableStateName = selectOption.completionStatusDict[val.receivableState]
        this.source.contentName = this.formatEnumeration(this.freeTypeList)[val.content]
      },
      deep: true,
    },
  },
  data() {
    return {
      list: [
        {
          key: 'id',
          name: '应收ID',
        },
        {
          key: 'receivableStateName',
          name: '收款状态',
        },
        {
          key: 'contentName',
          name: '收款内容',
        },
        {
          key: 'gmtCreate',
          name: '创建时间',
        },
        {
          key: 'completeTime',
          name: '完成时间',
        },
        {
          key: 'closeTime',
          name: '关闭时间',
        },
        {
          key: 'receivableAmount',
          name: '应收金额',
        },
        {
          key: 'receivedAmount',
          name: '已收金额',
        },
        {
          key: 'receivableDate',
          name: '应收日期',
        },
      ],
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
    this.source.receivableStateName = selectOption.completionStatusDict[this.source.receivableState]
    this.source.contentName = this.formatEnumeration(this.freeTypeList)[this.source.content]
  },
}
</script>

<style>

</style>
